import { RootState } from 'common/redux/core/root.reducer';

export const getPreviewData = (state: RootState) => state.previewData.previewData;

export const getSearchList = (state: RootState) => state.previewData.searchList.data?.data || [];

export const getSearchListPagination = (state: RootState) =>
    state.previewData.searchList.data?.pagination;

export const getSearchListStatus = (state: RootState) => state.previewData.searchList.status;

export const getErrorCount = (state: RootState) => state.previewData.errorCount;

export const getErrorFixedStatus = (state: RootState) => state.previewData.isAtleastOneErrorFixed;

export const getFieldErrors = (state: RootState) => state.previewData.fieldErrors;

export const getCurrentAction = (state: RootState) => state.previewData.currentAction;

export const getCategoryResponse = (state: RootState) => state.previewData.categoryResponse;
